export var defaultLocale = 'en-us';
var rightToLeftLocales = ['he-il', 'ar-il'];
export var isRightToLeft = function (locale) { return rightToLeftLocales.includes(locale.toLowerCase()); };
export var isAmPm = function (locale) {
    return new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).resolvedOptions().hour12;
};
export var getLocale = function (locale) { return locale || defaultLocale; };
export var isRtlLanguage = function (language) {
    if (language === void 0) { language = DEFAULT_LANGUAGE; }
    return ['ar', 'arc', 'dv', 'fa', 'ha', 'he', 'khw', 'ks', 'ku', 'ps', 'ur', 'yi'].includes(language);
};
export var DEFAULT_LANGUAGE = 'en';
export var isLanguageBabelSupported = function (language) { return SUPPORTED_BABEL_LANGUAGES.includes(language); };
export var SUPPORTED_BABEL_LANGUAGES = [
    'ar',
    'bg',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'es',
    'fi',
    'fr',
    'he',
    'hi',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'ms',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'sv',
    'th',
    'tl',
    'tr',
    'uk',
    'zh',
    'vi',
];
//# sourceMappingURL=locale.js.map